import type { FC } from "react";
import { useEffect } from "react";

import styled from "styled-components";

import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

import {
    TIME_GRANULARITY,
    getTimeGranularityItems,
    INCLUDE_SUBDOMAINS,
    getBooleanFilterItems,
} from "./components/consts";
import { GenericDropdownFilter } from "./components/GenericDropdownFilter";

const AdIntelligenceAdvertiserPerformanceFiltersContainer = styled.div``;

const TITLE_KEY = "TimeGranularity";
const KEY = "dynamicFiltersContainer";
const DEFAULT_GRANULARITY = GranularityNames.WEEKLY;

interface IFilterObject {
    [TIME_GRANULARITY]: string;
}

export const AdIntelligenceAdvertiserPerformanceOvertimeGraphWidgetFilters: FC<any> = (props) => {
    const { widgetFilters: filterObject, changeFilter: onFilterChangeCallback } = props;

    useEffect(() => {
        if (!filterObject[TIME_GRANULARITY]) {
            onFilterChange(TIME_GRANULARITY, DEFAULT_GRANULARITY);
        }
    }, []);

    const onFilterChange = (filterName: keyof IFilterObject, value: string) => {
        const newData = { ...filterObject, [filterName]: value };

        const updatedFilters = Object.entries(newData).map(([key, value]) => ({
            name: key,
            value,
        }));

        onFilterChangeCallback(updatedFilters);
    };

    return (
        <AdIntelligenceAdvertiserPerformanceFiltersContainer
            key={KEY}
            className="filters"
        >
            <GenericDropdownFilter
                titleKey={TITLE_KEY}
                items={getTimeGranularityItems()}
                selectedId={filterObject[TIME_GRANULARITY] ?? DEFAULT_GRANULARITY}
                onSelect={(value) => onFilterChange(TIME_GRANULARITY, value.id)}
                filterContainerClass="overview-performance-dynamic-filters"
            />
            <GenericDropdownFilter
                titleKey={INCLUDE_SUBDOMAINS}
                items={getBooleanFilterItems()}
                selectedId={"true"}
                disabled
            />
        </AdIntelligenceAdvertiserPerformanceFiltersContainer>
    );
};
